<template>
  <vue100vh style="position: fixed; width: 100%;">
<div style="overflow-y: hidden;">
  <v-card>
    <v-card-text style="height: 100vh; overflow-y: scroll; margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
      <h2 style="text-align: center;text-decoration: underline;margin-top: 50px;" class="CSChatThai">{{$t('Settings.policy.header')}}
      </h2>
      <br>
      <h3 class="CSChatThai">&emsp;&emsp;{{$t('Settings.policy.subject1.header')}}</h3>
      <p class="CSChatThai" style="padding: 1vw; font-size: 13px;">&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject1.introDetail')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro1')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro2')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro3')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro4')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro5')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro6')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro7')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro8')}}
      </p>
      <h3 class="CSChatThai">&emsp;&emsp;{{$t('Settings.policy.subject2.header')}}</h3>
      <p class="CSChatThai" style="padding: 1vw;font-size: 13px;"> <b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.subHeaderScopeA')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.detailScopeA1')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.detailScopeA2')}}<br>
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.subHeaderScopeB')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.detailScopeB1')}}
      </p>
      <h3 class="CSChatThai">&emsp;&emsp;{{$t('Settings.policy.subject3.header')}}</h3>
      <p class="CSChatThai" style="padding: 1vw; font-size: 13px;"><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subHeaderTypeA')}}</b>
        &emsp;{{$t('Settings.policy.subject3.detailSubHeaderA')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectA1')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectA1')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectA2')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectA2')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectA21')}}<br>
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subHeaderTypeB')}}</b>
        &emsp;{{$t('Settings.policy.subject3.detailSubHeaderB')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB1')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB1')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB2')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB2')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB2')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB3')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB3')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB4')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB41')}}
        <br>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB42')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB5')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB51')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB52')}}

        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB6')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB6')}}
          <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB7')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB71')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB72')}}

        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB8')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB8')}}

        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB9')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB91')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB92')}}
         
        <br></p>
      <h3 class="CSChatThai">&emsp;&emsp;{{$t('Settings.policy.subject4.header')}}</h3>
      <p class="CSChatThai" style="font-size: 13px; padding: 1vw;"><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectA')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectA')}}


        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA1')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA2')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA3')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA4')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA5')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA6')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA7')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA8')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA9')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA10')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA11')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA12')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA13')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA14')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA15')}}

        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectA16')}}

         <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectB')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectB1')}}

        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectB2')}}

        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectC')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectC')}}
         <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectD')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectD1')}}
        <br>&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectD2')}}
        <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD3')}}
        <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD4')}}
        <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD5')}}
        <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD6')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectE')}}</b>
        <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectE')}}
         <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectF')}}</b>
        <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectF')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectG')}}</b>
        <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG1')}}
        <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG2')}}
        <br> &emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG3')}}
        <br> &emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG4')}}
        <br> &emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG5')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG6')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG7')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG8')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG9')}}
        <br></p>
      <h3 class="CSChatThai">&emsp;&emsp;{{$t('Settings.policy.subject5.header')}}</h3>  
      <p class="CSChatThai" style="padding: 1vw; font-size: 13px;">&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailHeader')}}
          <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.subjectA')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectA')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectA1')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectA2')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectA3')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectA4')}} 
         <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.subjectB')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectB')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB1')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB2')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB3')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB4')}}
        <br></p>
      <h3 class="CSChatThai">&emsp;&emsp;{{$t('Settings.policy.subject6.header')}}</h3>
      <p class="CSChatThai" style="padding: 1vw; font-size: 13px;"><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.subjectA')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.detailSubjectA')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.subjectB')}}</b>
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.detailSubjectB1')}}
        <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.detailSubjectB2')}}

        <br></p>
      <br>
    </v-card-text>
  </v-card>
</div>
</vue100vh>
</template>
<script>
import vue100vh from 'vue-100vh'
export default {
  data() {
    return {
      // policydialog: true
    }
  },
  components: {
    vue100vh
  },
  created () {
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },
  methods: {
    toPage(data) {
      this.$router.push(data)
    }
  }
}
</script>
<style type="text/css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
}
>>>.v-card__text {
  padding-right: 8px;
  padding-left: 8px;
  /* padding: 0px; */
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/settings/PolicyMobile.vue